export enum USER_REQUEST_IDENTIFIERS {
  'PROFILE' = 'user.profile',
  'CLUSTER' = 'user.cluster',
  'COLLABORATOR' = 'user.collaborator',
  'COLLABORATOR_PENDING_INVITES' = 'user.collaborator_pending_invites',
  'USER_FROM' = 'user.is_from'
}

export enum USER_AUTHORITIES {
  USER_BR = 'user_br',
  USER_ES = 'user_es',
  USER_FR = 'user_fr',
  USER_BUYER = 'comprador',
  USER_ATTENDANT = 'attendant',
  USER_PRODUCER = 'produtor',
  USER_SELER = 'vendedor',
  USER_PLATFORM_SIGNUP = 'PLATFORM_SIGNUP'
}

export enum CENTRAL_AUTHORITIES {
  ACCESS_STATEMENT = 'ACCESS_STATEMENT',
  MANAGE_AFFILIATE = 'MANAGE_AFFILIATE',
  MANAGE_SALES_MANAGEMENT = 'MANAGE_SALES_MANAGEMENT',
  MANAGE_SUBSCRIPTION = 'MANAGE_SUBSCRIPTION',
  CHAT = 'CHAT',
  MANAGE_EXPORTED_REPORTS = 'MANAGE_EXPORTED_REPORTS',
  MANAGE_TOOLS_KAJABI = 'MANAGE_TOOLS_KAJABI',
  MANAGE_TOOLS_TRACKING_PIXEL = 'MANAGE_TOOLS_TRACKING_PIXEL',
  MANAGE_TOOLS_NOTIFICATIONS = 'MANAGE_TOOLS_NOTIFICATIONS',
  MANAGE_TOOLS_INTEGRATIONS = 'MANAGE_TOOLS_INTEGRATIONS',
  MANAGE_TOOLS_LISTBOSS = 'MANAGE_TOOLS_LISTBOSS',
  MEM_MANAGE_PRODUCT = 'MEM_MANAGE_PRODUCT',
  MEM_MANAGE_MEMBERSHIP = 'MEM_MANAGE_MEMBERSHIP',
  WITHDRAW = 'WITHDRAW',
  NOT_SHOW_IN_CENTRAL = 'NOT_SHOW_IN_CENTRAL'
}

export enum USER_CLUSTERS_INITIALS {
  'PROJECT NEGATIVE' = 'NEG',
  'PROJECT NOT ACTIVATED' = 'NAC',
  'PROJECT ACTIVATED AFFILIATE' = 'AAF',
  'PROJECT DRAFT CREATOR' = 'DCR',
  'PROJECT ACTIVATED CREATOR' = 'ACR',
  'PROJECT FIRST SALES' = 'FTS',
  'PROJECT 1' = 'PR1',
  'PROJECT 2' = 'PR2',
  'PROJECT 3' = 'PR3',
  'PROJECT 4' = 'PR4',
  'PROJECT 5' = 'PR5',
  'HOTMART BUILD' = 'BLD',
  'HOTMART SPACESHIP' = 'SPC',
  'HOTMART MISSION' = 'MSN',
  'HOTMART BLACK ONE' = 'BL1',
  'HOTMART BLACK MOON' = 'BMN',
  'HOTMART BLACK VENUS' = 'BVN',
  'HOTMART BLACK SUN' = 'BSN',
  'HOTMART BLACK SIRIUS' = 'BSR',
  'COSMOS I' = 'CO1',
  'COSMOS II' = 'CO2',
  'COSMOS III' = 'CO3'
}

export enum USER_ROLES {
  USER_BW_BETA_HOTMART = 'BW_BETA_HOTMART'
}

export enum BETA_AUTHORITIES {
  SUBSCRIPTION_RETENTION_STRATEGIES = 'BETA_SUBSCRIPTION_RETENTION_STRATEGIES'
}
